/* eslint-disable */
/*
This is from the npm package 'react-truncate v2.3.0' (https://www.npmjs.com/package/react-truncate) which has been 
modified(lines 367 - 375) to break on words rather than on letters to provide a better user experience. 
*/

var _extends =
	Object.assign ||
	function (target) {
		for (var i = 1; i < arguments.length; i++) {
			var source = arguments[i];
			for (var key in source) {
				if (Object.prototype.hasOwnProperty.call(source, key)) {
					target[key] = source[key];
				}
			}
		}
		return target;
	};

var _createClass = (function () {
	function defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i];
			descriptor.enumerable = descriptor.enumerable || false;
			descriptor.configurable = true;
			if ('value' in descriptor) descriptor.writable = true;
			Object.defineProperty(target, descriptor.key, descriptor);
		}
	}
	return function (Constructor, protoProps, staticProps) {
		if (protoProps) defineProperties(Constructor.prototype, protoProps);
		if (staticProps) defineProperties(Constructor, staticProps);
		return Constructor;
	};
})();

function _objectWithoutProperties(obj, keys) {
	var target = {};
	for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;
		if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
		target[i] = obj[i];
	}
	return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError('Cannot call a class as a function');
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError(
			"this hasn't been initialised - super() hasn't been called"
		);
	}
	return call && (typeof call === 'object' || typeof call === 'function')
		? call
		: self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== 'function' && superClass !== null) {
		throw new TypeError(
			'Super expression must either be null or a function, not ' +
				typeof superClass
		);
	}
	subClass.prototype = Object.create(superClass && superClass.prototype, {
		constructor: {
			value: subClass,
			enumerable: false,
			writable: true,
			configurable: true
		}
	});
	if (superClass)
		Object.setPrototypeOf
			? Object.setPrototypeOf(subClass, superClass)
			: (subClass.__proto__ = superClass);
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';

var Truncate = (function (_Component) {
	_inherits(Truncate, _Component);

	function Truncate() {
		var _ref;

		_classCallCheck(this, Truncate);

		for (
			var _len = arguments.length, args = Array(_len), _key = 0;
			_key < _len;
			_key++
		) {
			args[_key] = arguments[_key];
		}

		var _this = _possibleConstructorReturn(
			this,
			(_ref =
				Truncate.__proto__ ||
				Object.getPrototypeOf(Truncate)).call.apply(
				_ref,
				[this].concat(args)
			)
		);

		_this.state = {};
		_this.styles = {
			ellipsis: {
				position: 'fixed',
				visibility: 'hidden',
				top: 0,
				left: 0
			}
		};

		_this.elements = {};

		_this.onResize = _this.onResize.bind(_this);
		_this.onTruncate = _this.onTruncate.bind(_this);
		_this.calcTargetWidth = _this.calcTargetWidth.bind(_this);
		_this.measureWidth = _this.measureWidth.bind(_this);
		_this.getLines = _this.getLines.bind(_this);
		_this.renderLine = _this.renderLine.bind(_this);
		return _this;
	}

	_createClass(Truncate, [
		{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var text = this.elements.text,
					calcTargetWidth = this.calcTargetWidth,
					onResize = this.onResize;

				var canvas = document.createElement('canvas');
				this.canvasContext = canvas.getContext('2d');

				calcTargetWidth(function () {
					// Node not needed in document tree to read its content
					if (text) {
						text.parentNode.removeChild(text);
					}
				});

				window.addEventListener('resize', onResize);
			}
		},
		{
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				// Render was based on outdated refs and needs to be rerun
				if (this.props.children !== prevProps.children) {
					this.forceUpdate();
				}
			}
		},
		{
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var ellipsis = this.elements.ellipsis,
					onResize = this.onResize,
					timeout = this.timeout;

				ellipsis.parentNode.removeChild(ellipsis);

				window.removeEventListener('resize', onResize);

				window.cancelAnimationFrame(timeout);
			}

			// Shim innerText to consistently break lines at <br/> but not at \n
		},
		{
			key: 'innerText',
			value: function innerText(node) {
				var div = document.createElement('div');
				var contentKey =
					'innerText' in window.HTMLElement.prototype
						? 'innerText'
						: 'textContent';

				div.innerHTML = node.innerHTML.replace(/\r\n|\r|\n/g, ' ');

				var text = div[contentKey];

				var test = document.createElement('div');
				test.innerHTML = 'foo<br/>bar';

				if (test[contentKey].replace(/\r\n|\r/g, '\n') !== 'foo\nbar') {
					div.innerHTML = div.innerHTML.replace(
						/<br.*?[\/]?>/gi,
						'\n'
					);
					text = div[contentKey];
				}

				return text;
			}
		},
		{
			key: 'onResize',
			value: function onResize() {
				this.calcTargetWidth();
			}
		},
		{
			key: 'onTruncate',
			value: function onTruncate(didTruncate) {
				var onTruncate = this.props.onTruncate;

				if (typeof onTruncate === 'function') {
					this.timeout = window.requestAnimationFrame(function () {
						onTruncate(didTruncate);
					});
				}
			}
		},
		{
			key: 'calcTargetWidth',
			value: function calcTargetWidth(callback) {
				var target = this.elements.target,
					calcTargetWidth = this.calcTargetWidth,
					canvasContext = this.canvasContext;
				// Calculation is no longer relevant, since node has been removed

				if (!target) {
					return;
				}

				// Floor the result to deal with browser subpixel precision
				var targetWidth = Math.floor(
					target.parentNode.getBoundingClientRect().width
				);

				// Delay calculation until parent node is inserted to the document
				// Mounting order in React is ChildComponent, ParentComponent
				if (!targetWidth) {
					return window.requestAnimationFrame(function () {
						return calcTargetWidth(callback);
					});
				}

				var style = window.getComputedStyle(target);

				var font = [
					style['font-weight'],
					style['font-style'],
					style['font-size'],
					style['font-family']
				].join(' ');

				canvasContext.font = font;
				this.setState(
					{
						targetWidth: targetWidth
					},
					callback
				);
			}
		},
		{
			key: 'measureWidth',
			value: function measureWidth(text) {
				return this.canvasContext.measureText(text).width;
			}
		},
		{
			key: 'ellipsisWidth',
			value: function ellipsisWidth(node) {
				return node.offsetWidth;
			}
		},
		{
			key: 'trimRight',
			value: function trimRight(text) {
				return text.replace(/\s+$/, '');
			}
		},
		{
			key: 'getLines',
			value: function getLines() {
				var elements = this.elements,
					_props = this.props,
					numLines = _props.lines,
					ellipsis = _props.ellipsis,
					trimWhitespace = _props.trimWhitespace,
					targetWidth = this.state.targetWidth,
					innerText = this.innerText,
					measureWidth = this.measureWidth,
					onTruncate = this.onTruncate,
					trimRight = this.trimRight;

				var text = innerText(elements.text);
				var didTruncate = false;
				var ellipsisWidth = this.ellipsisWidth(this.elements.ellipsis);

				// Calculate approximate line height based on target width and number of lines
				var approximateLineWidth = targetWidth * numLines;

				// If text fits in the available space, don't truncate
				if (measureWidth(text) <= approximateLineWidth) {
					onTruncate(false);
					return [text];
				}

				// Text needs truncation - find the best breaking point
				var words = text.split(' ');
				var truncatedText = '';

				for (var i = 0; i < words.length; i++) {
					var testText =
						truncatedText + (truncatedText ? ' ' : '') + words[i];

					if (
						measureWidth(testText) + ellipsisWidth <=
						approximateLineWidth
					) {
						truncatedText = testText;
					} else {
						didTruncate = true;
						break;
					}
				}

				// If we truncated, add the ellipsis
				if (didTruncate) {
					var result = React.createElement(
						'span',
						null,
						truncatedText,
						ellipsis
					);
					onTruncate(true);
					return [result];
				}

				onTruncate(false);
				return [truncatedText || text];
			}
		},
		{
			key: 'renderLine',
			value: function renderLine(line, i, arr) {
				// For multi-line truncation, we want to render all lines as a single text flow
				// rather than separate spans with breaks
				return line;
			}
		},
		{
			key: 'render',
			value: function render() {
				var _this2 = this;

				var target = this.elements.target,
					_props2 = this.props,
					children = _props2.children,
					ellipsis = _props2.ellipsis,
					lines = _props2.lines,
					spanProps = _objectWithoutProperties(_props2, [
						'children',
						'ellipsis',
						'lines'
					]),
					targetWidth = this.state.targetWidth,
					getLines = this.getLines,
					renderLine = this.renderLine,
					onTruncate = this.onTruncate;

				var text = void 0;

				var mounted = !!(target && targetWidth);

				if (typeof window !== 'undefined' && mounted) {
					if (lines > 0) {
						var linesArray = getLines();
						// Since we now return a single item or React element, use it directly
						text = linesArray[0];
					} else {
						text = children;

						onTruncate(false);
					}
				}

				delete spanProps.onTruncate;
				delete spanProps.trimWhitespace;

				return React.createElement(
					'span',
					_extends({}, spanProps, {
						ref: function ref(targetEl) {
							_this2.elements.target = targetEl;
						}
					}),
					React.createElement('span', null, text),
					React.createElement(
						'span',
						{
							ref: function ref(textEl) {
								_this2.elements.text = textEl;
							}
						},
						children
					),
					React.createElement(
						'span',
						{
							ref: function ref(ellipsisEl) {
								_this2.elements.ellipsis = ellipsisEl;
							},
							style: this.styles.ellipsis
						},
						ellipsis
					)
				);
			}
		}
	]);

	return Truncate;
})(Component);

Truncate.propTypes = {
	children: PropTypes.node,
	ellipsis: PropTypes.node,
	lines: PropTypes.oneOfType([PropTypes.oneOf([false]), PropTypes.number]),
	trimWhitespace: PropTypes.bool,
	onTruncate: PropTypes.func
};
Truncate.defaultProps = {
	children: '',
	ellipsis: '…',
	lines: 1,
	trimWhitespace: false
};
export default Truncate;
